module.exports = __webpack_public_path__ + "static/img/22.cbe2c6e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/2/sp/22.png
// module id = M/ml
// module chunks = 0